import type { ProductVariantFieldsFragment } from '../../../client/__generated__/graphql-client-types';
import { useRouterHistory } from '../routing/history.hook';
import { useRouterLocation } from '../routing/location.hook';

/**
 * Hook to update the url when a variant is selected on product pages.
 */
export function useUpdateUrlOnVariantChange() {
	const history = useRouterHistory();
	const { search } = useRouterLocation();
	function updateURL(selectedVariant: ProductVariantFieldsFragment) {
		const queryParams = new URLSearchParams(search);
		const selectedVariantId = selectedVariant.id.toString();
		if (selectedVariant && queryParams.get('uid') !== selectedVariantId) {
			queryParams.set('uid', selectedVariantId);
			history.replace({ search: queryParams.toString() });
		}
	}
	return updateURL;
}
